import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogIn } from 'lucide-react';

const Login = () => {
    const [credentials, setCredentials] = useState({
        idString: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await login(credentials);
            navigate('/');
        } catch (error) {
            setError(error.response?.data?.message || '로그인에 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="flex-center" style={{ minHeight: '100vh', backgroundColor: '#f3f4f6' }}>
            <div className="card" style={{ width: '100%', maxWidth: '400px' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <img 
                        src="/logo.png" 
                        alt="묘원365 로고" 
                        style={{ 
                            width: '80px', 
                            height: '80px', 
                            objectFit: 'contain', 
                            margin: '0 auto 20px',
                            display: 'block'
                        }}
                    />
                    <h1 className="text-2xl font-bold text-gray-900 mb-4">
                        묘원365
                    </h1>
                    <p className="text-gray-600">
                        묘지 관리자 계정으로 로그인하세요
                    </p>
                </div>

                {error && (
                    <div className="error">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                            아이디
                        </label>
                        <input
                            type="text"
                            name="idString"
                            value={credentials.idString}
                            onChange={handleChange}
                            className="input"
                            placeholder="아이디를 입력하세요"
                            required
                        />
                    </div>

                    <div className="mb-6">
                        <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                            비밀번호
                        </label>
                        <input
                            type="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            className="input"
                            placeholder="비밀번호를 입력하세요"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary"
                        style={{ width: '100%', padding: '12px' }}
                    >
                        <LogIn size={20} />
                        {loading ? '로그인 중...' : '로그인'}
                    </button>
                </form>

                {/* 회사 정보 */}
                <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                    <div className="text-xs text-gray-500" style={{ lineHeight: '1.6' }}>
                        <div style={{ marginBottom: '8px' }}>
                            에이원링크 주식회사 | 대표이사 강성구 | 사업자등록번호 511-81-24627 | 통신판매업신고번호 : 제2022-제주용담1-0002호
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            주소 : 전라북도 익산시 성당면 성당로 413-114 (우)54504 | 고객센터 : 010-6453-8599 (평일 09:00~18:00)
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            이메일 : aonelink20151111@gmail.com | 호스팅서비스사업자 : 에이원링크 주식회사
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            개인정보보호책임자 : 김재환
                        </div>
                        <div style={{ textAlign: 'center', marginTop: '12px', fontSize: '10px' }}>
                            Copyright © Aonelink Co., Ltd. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;